import React from "react";
import Calendar from "../../Components/Calendar/Calendar";

const CalendarPage : React.FC = () => {

    return (
        <div>
            <Calendar/>
        </div>
    );
}
export default CalendarPage;